var React = require('react');

function CreditCard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 3.75C2.17157 3.75 1.5 4.42157 1.5 5.25V12.75C1.5 13.5785 2.17157 14.25 3 14.25H15C15.8285 14.25 16.5 13.5785 16.5 12.75V5.25C16.5 4.42157 15.8285 3.75 15 3.75H3ZM3.75 5.25C3.33579 5.25 3 5.58579 3 6V12C3 12.4142 3.33579 12.75 3.75 12.75H14.25C14.6642 12.75 15 12.4142 15 12V6C15 5.58579 14.6642 5.25 14.25 5.25H3.75Z","fill":"white","key":0}),React.createElement("path",{"d":"M1.5 6.75H16.5V8.25H1.5V6.75ZM4.5 10.5H9V11.25H4.5V10.5Z","fill":"white","key":1})]);
}

CreditCard.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = CreditCard;

CreditCard.default = CreditCard;
